<template>
  <div class="row">
    <div class="col">
      <div class="row mb-3">
        <div class="col-1">
          <button
            class="btn btn-info"
            @click="setAddEdit(false)"
          >
            <i class="fa fa-arrow-left"></i>
          </button>
        </div>
        <div class="col">
          <h4 v-if="form.id">{{ $t('gpool.tournament_edit_tournament') }}</h4>
          <h4 v-else>{{ $t('gpool.tournament_add_tournament') }}</h4>
        </div>
      </div>
      <div class="row">
        <form
          @submit.prevent="
            form.id
              ? saveTournament($route.params.id)
              : addTournament($route.params.id)
          "
        >
          <div class="col">
            <div class="card">
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col">
                    <label
                      for="name"
                      class="form-label"
                    >
                      {{ $t('gpool.tournament_name') }}
                    </label>
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      :placeholder="$t('gpool.tournament_name')"
                      v-model="form.name"
                    />
                  </div>
                  <div class="col">
                    <label
                      for="daterange"
                      class="form-label"
                    >
                      {{ $t('gpool.tournament_daterange') }}
                    </label>
                    <date-range-picker
                      ref="picker"
                      name="daterange"
                      :timePicker="true"
                      :timePicker24Hour="true"
                      :time-picker-increment="1"
                      opens="left"
                      v-model="daterange"
                      format="dd-MM-yyyy HH:mm:ss"
                      style="display: block"
                    >
                      <template
                        v-slot:input="picker"
                        style="min-width: 350px"
                      >
                        {{ picker.startDate | date }} -
                        {{ picker.endDate | date }}
                      </template>
                    </date-range-picker>
                  </div>
                  <div class="col">
                    <label for="isDaily">
                      {{ $t('gpool.tournament_isdaily') }}
                    </label>
                    <div class="checkbox-wrapper-14 mt-3">
                      <input
                        id="s1-14"
                        type="checkbox"
                        class="switch"
                        v-model="form.is_daily"
                      />
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <label
                      for="description"
                      class="form-label"
                    >
                      {{ $t('gpool.tournament_description') }}
                    </label>
                    <wysiwyg
                      v-model="form.description"
                      :options="{
                        height: 300,
                        hideModules: {
                          link: true,
                          code: true,
                          image: true,
                          table: true
                        }
                      }"
                    />
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col">
                    <div class="row mb-2">
                      <div class="col">
                        <label
                          for="awards"
                          class="form-label"
                        >
                          {{ $t('gpool.tournaments_awards') }}
                        </label>
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="addAward"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                        <div
                          class="row my-2"
                          v-for="(item, index) in form.awards"
                        >
                          <div class="col-3">
                            <input
                              type="number"
                              class="form-control"
                              v-model="item.min"
                              v-digit-only
                              required
                              min="1"
                              :placeholder="$t('gpool.tournament_award_min')"
                            />
                          </div>
                          -
                          <div class="col-3">
                            <input
                              type="number"
                              class="form-control"
                              v-model="item.max"
                              required
                              v-digit-only
                              min="1"
                              :placeholder="$t('gpool.tournament_award_max')"
                            />
                          </div>
                          :
                          <div class="col">
                            <input
                              type="text"
                              class="form-control"
                              v-model="item.award"
                              v-alphanumeric-only
                              required
                              :placeholder="$t('gpool.tournament_award')"
                            />
                          </div>
                          <div class="col-1">
                            <button
                              type="button"
                              class="btn btn-danger"
                              @click="removeAward(index)"
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col">
                        <label class="form-label">
                          {{ $t('gpool.tournament_score_rules') }}
                        </label>
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="addScore"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                        <div
                          class="row my-2"
                          v-for="item in form.score_rules"
                        >
                          <div class="col">
                            <select
                              name="fields"
                              v-model="item.field"
                              class="form-control"
                              required
                            >
                              <option value="">
                                {{ $t('gpool.tournament_select_score') }}
                              </option>
                              <option
                                v-for="score in scores"
                                :key="score.value"
                                :value="score.value"
                              >
                                {{ $t(`gpool.tournament_score_${score.name}`) }}
                              </option>
                            </select>
                          </div>
                          <div class="col">
                            <select
                              name="fields"
                              v-model="item.operator"
                              class="form-control"
                              required
                            >
                              <option value="">
                                {{ $t('gpool.tournament_select_operator') }}
                              </option>
                              <option
                                v-for="operator in operators"
                                :key="operator.value"
                                :value="operator.value"
                              >
                                {{
                                  $t(
                                    `gpool.tournament_operator_${operator.name}`
                                  )
                                }}
                              </option>
                            </select>
                          </div>
                          <div class="col">
                            <input
                              type="number"
                              class="form-control"
                              v-model="item.value"
                              :placeholder="$t('gpool.tournament_value')"
                              required
                            />
                          </div>
                          <div class="col-1">
                            <button
                              type="button"
                              class="btn btn-danger"
                              @click="removeScore({ item_id: item.id })"
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <label
                      for="logo"
                      class="form-label"
                      >Banner</label
                    >
                    <br />
                    <template v-if="form.logo_url">
                      <img
                        :src="form.logo_url"
                        style="max-width: 350px; max-height: 150px"
                      />
                      <button
                        class="btn btn-danger"
                        @click="removeLogo"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </template>
                    <input
                      type="file"
                      name="logo"
                      @change="addLogo"
                      class="form-control"
                      v-else
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label class="form-label">
                      {{ $t('gpool.tournament_rules') }}
                    </label>
                    <div class="row mb-2">
                      <div class="col">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="addItem('and')"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                        <strong>
                          {{ $t('gpool.tournament_rules_and') }}
                        </strong>
                        <div
                          class="row my-2"
                          v-for="item in form.rules.and"
                        >
                          <div class="col">
                            <select
                              name="fields"
                              v-model="item.field"
                              class="form-control"
                              required
                            >
                              <option value="">
                                {{ $t('gpool.tournament_select_field') }}
                              </option>
                              <option
                                v-for="field in fields"
                                :key="field.value"
                                :value="field.value"
                              >
                                {{ $t(`gpool.tournament_field_${field.name}`) }}
                              </option>
                            </select>
                          </div>
                          <div class="col">
                            <select
                              name="fields"
                              v-model="item.operator"
                              class="form-control"
                              required
                            >
                              <option value="">
                                {{ $t('gpool.tournament_select_operator') }}
                              </option>
                              <option
                                v-for="operator in operators"
                                :key="operator.value"
                                :value="operator.value"
                              >
                                {{
                                  $t(
                                    `gpool.tournament_operator_${operator.name}`
                                  )
                                }}
                              </option>
                            </select>
                          </div>
                          <div class="col">
                            <input
                              type="number"
                              class="form-control"
                              v-model="item.value"
                              :placeholder="$t('gpool.tournament_value')"
                              required
                            />
                          </div>
                          <div class="col-1">
                            <button
                              type="button"
                              class="btn btn-danger"
                              @click="
                                removeItem({ type: 'and', item_id: item.id })
                              "
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="addItem('or')"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                        <strong>
                          {{ $t('gpool.tournament_rules_or') }}
                        </strong>
                        <div
                          class="row my-2"
                          v-for="item in form.rules.or"
                        >
                          <div class="col">
                            <select
                              name="fields"
                              v-model="item.field"
                              class="form-control"
                              required
                            >
                              <option value="">
                                {{ $t('gpool.tournament_select_field') }}
                              </option>
                              <option
                                v-for="field in fields"
                                :key="field.value"
                                :value="field.value"
                              >
                                {{ $t(`gpool.tournament_field_${field.name}`) }}
                              </option>
                            </select>
                          </div>
                          <div class="col">
                            <select
                              name="fields"
                              v-model="item.operator"
                              class="form-control"
                              required
                            >
                              <option value="">
                                {{ $t('gpool.tournament_select_operator') }}
                              </option>
                              <option
                                v-for="operator in operators"
                                :key="operator.value"
                                :value="operator.value"
                              >
                                {{
                                  $t(
                                    `gpool.tournament_operator_${operator.name}`
                                  )
                                }}
                              </option>
                            </select>
                          </div>
                          <div class="col">
                            <input
                              type="number"
                              class="form-control"
                              v-model="item.value"
                              :placeholder="$t('gpool.tournament_value')"
                              required
                            />
                          </div>
                          <div class="col-1">
                            <button
                              type="button"
                              class="btn btn-danger"
                              @click="
                                removeItem({ type: 'or', item_id: item.id })
                              "
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <label class="form-label">
                      {{ $t('gpool.tournament_games') }}
                    </label>
                    <Select2
                      class="mb-3"
                      v-model="selected_game"
                      :options="
                        games
                          .map(c => ({ id: c.id, text: c.name }))
                          .filter(g => !form.games.includes(g.id))
                      "
                      :settings="{
                        placeholder: $t('gpool.tournament_select_game')
                      }"
                      @change="onGameSelect"
                    />
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th>{{ $t('gpool.tournament_table_game_name') }}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="game in selected_games">
                          <td>{{ game.name }}</td>
                          <td>
                            <button
                              type="button"
                              class="btn btn-danger btn-sm"
                              @click="removeGame(game.id)"
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <button
                  class="btn btn-success"
                  type="submit"
                >
                  <i class="fa fa-save"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { mapState, mapActions, mapGetters } from 'vuex'
import Select2 from 'v-select2-component'

export default {
  name: 'AddEditTournament',
  directives: {
    'digit-only': {
      bind(el) {
        el.addEventListener('input', function (event) {
          const inputValue = event.target.value
          const sanitizedValue = inputValue.replace(/[e.]/gi, '')
          event.target.value = sanitizedValue
        })
      }
    },
    'alphanumeric-only': {
      bind(el) {
        el.addEventListener('input', function (event) {
          const inputValue = event.target.value
          const sanitizedValue = inputValue.replace(/[^a-zA-Z0-9. ]/gi, '')
          event.target.value = sanitizedValue
        })
      }
    }
  },
  components: {
    DateRangePicker,
    Select2
  },
  beforeDestroy() {
    this.setAddEdit(false)
  },
  filters: {
    date: function (value) {
      if (!value) return ''
      return moment(value).format('DD.MM.YYYY HH:mm:ss')
    }
  },
  computed: {
    ...mapGetters('game', ['games']),
    ...mapState('tournament', [
      'form',
      'selected_games',
      'operators',
      'fields',
      'scores'
    ]),
    daterange: {
      get() {
        return this.$store.state.tournament.daterange
      },
      set(value) {
        this.$store.state.tournament.daterange = value
      }
    },
    selected_game: {
      get() {
        return this.$store.state.tournament.selected_game
      },
      set(value) {
        this.$store.state.tournament.selected_game = value
      }
    }
  },
  methods: {
    ...mapActions('tournament', [
      'addTournament',
      'onGameSelect',
      'removeGame',
      'addItem',
      'removeItem',
      'setAddEdit',
      'saveTournament',
      'addLogo',
      'removeLogo',
      'addAward',
      'removeAward',
      'addScore',
      'removeScore'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AddEditTournament.vue